import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { LanguageProvider } from './contexts/LanguageContext';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Consulting from './pages/Consulting';
import Partnerships from './pages/Partnerships';
import Legal from './pages/Legal';
import BlogPost from './pages/BlogPost';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Global styles
const AppContainer = styled.div`
  font-family: 'Inter', sans-serif;
  color: #333;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const ContentContainer = styled.main`
  flex: 1;
  padding: 0;
  margin: 0;
`;

// Component to handle hash scrolling
function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Wait a bit for the page to render
      setTimeout(() => {
        const id = location.hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          const top = element.offsetTop;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Scroll to top if no hash
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToHash />
        <AppContainer>
          <Navbar />
          <ContentContainer>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/consulting" element={<Consulting />} />
              <Route path="/partnerships" element={<Partnerships />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
            </Routes>
          </ContentContainer>
          <Footer />
        </AppContainer>
      </Router>
    </LanguageProvider>
  );
}

export default App;
